import { Map } from 'immutable';
import actions from '../../constants/portal/institutions';

const defaultState = () => new Map({
  institutionsList: undefined,
  institutionsSubordinateList: undefined,
  institutionDetail: undefined,
  institutionPersonal: undefined,
  institutionPersonalDetail: undefined,
  institutionServices: undefined,
  institutionServiceDetail: undefined,
  institutionsIsLoading: false,
  accostList: undefined,
  accost: new Map(),
  accostDetail: undefined,
  rating: undefined,
  ratingDetail: undefined,
  ratingExist: undefined,
  professions: undefined,
  institutionsLoaded: false,
  parentInst: new Map(),
  currentUserInstitutions: undefined,
  currentUserInstitutionsIsLoading: false,

  allTypes: new Map(),
  allTypesAreLoading: true
})

export default (state = defaultState(), action) => {
  switch (action.type) {
    case actions.LOAD_MEDICAL_INSTITUTIONS:
      return state.set('institutionsList', action.data);
    case actions.LOAD_SUBORDINATE_INSTITUTIONS:
      return state.set('institutionsSubordinateList', action.data);
    case actions.LOAD_INSTITUTION_DETAIL:
      return state.set('institutionDetail', action.data);
    case actions.LOAD_INSTITUTION_PERSONAL:
      return state.set('institutionPersonal', action.data);
    case actions.LOAD_INSTITUTION_PERSONAL_DETAIL:
      return state.set('institutionPersonalDetail', action.data);
    case actions.CLEAN_INSTITUTION_PERSONAL_DETAIL:
      return state.set('institutionPersonalDetail', undefined);
    case actions.LOAD_INSTITUTION_SERVICES:
      return state.set('institutionServices', action.data);
    case actions.LOAD_INSTITUTION_SERVICE_DETAIL:
      return state.set('institutionServiceDetail', action.data);
    case actions.CLEAN_INSTITUTION_SERVICE_DETAIL:
      return state.set('institutionServiceDetail', undefined);
    case actions.INSTITUTIONS_IS_LOADING:
      return state.set('institutionsIsLoading', action.data);
    case actions.LOAD_ACCOSTS:
      return state.set('accostList', action.data);
    case actions.LOAD_ACCOST_DETAIL:
      return state.set('accostDetail', action.data);
    case actions.SET_ACCOST_ITEM:
      return state.set('accost', action.data);
    case actions.SET_ACCOST_ITEM_VALUE:
      return state.setIn(['accost', action.key], action.data);
    case actions.LOAD_RATING:
      return state.set('rating', action.data);
    case actions.LOAD_RATING_DETAIL:
      return state.set('ratingDetail', action.data);
    case actions.CHANGE_RATING_COMMENT:
      return state.setIn(['ratingDetail', 'answer'], action.data);
    case actions.CHECK_RATING:
      return state.set('ratingExist', action.data);
    case actions.INSTITUTIONS_IS_LOADED:
      return state.set('institutionsLoaded', action.data);
    case actions.LOAD_PROFESSION_CLASSIFICATION:
      return state.set('professions', action.data);
    case actions.LOAD_CURRENT_USER_INSTITUTIONS:
      return state.set('currentUserInstitutions', action.data);
    case actions.CURRENT_USER_INSTITUTIONS_IS_LOADING:
      return state.set('currentUserInstitutionsIsLoading', action.data);
    case actions.CLEAN_CURRENT_USER_INSTITUTIONS:
      return state.set('currentUserInstitutions', undefined)
    case actions.LOAD_INSTITUTION_PARENT:
      return state.set('parentInst', action.data);

    case actions.LOAD_ALL_TYPES:
      return state.set('allTypes', action.data);
    case actions.ALL_TYPES_ARE_LOADING:
      return state.set('allTypesAreLoading', action.data);

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/portal/institutions.js